#import "../fragments/tag-basic.graphql"

mutation SelectCreateTag($tag: CreateTagInput!) {
    createTag(input: $tag) {
        tag {
            ...TagBasic
        }
    }
}
